<div class="contentHeight principale">
  <h1 class="text-center containerTitle">Importation du fichier de teinte Renault</h1>
  <div class="backgroundWhiteRound import">
    <div class="content">
      <div class="colorBook">
        <h3>ColorBook</h3>
        <div>
          <span> <strong>Sélectionner le fichier des teintes accessoires</strong></span><br />
          <input #file1 type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, file1)" />
          <button (click)="sendShades()">Importer</button>
        </div>
        <br />
        <div>
          <span> <strong>Sélectionner le fichier des aérosols</strong></span><br />
          <input #file2 type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, file2)" />
          <button (click)="sendAero()">Importer</button>
        </div>
        <br />
        <div>
          <span> <strong>Sélectionner le fichier des couleurs</strong></span><br />
          <input #file3 type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, file3)" />
          <button (click)="sendColor()">Importer</button>
        </div>

      </div>

      <div class="user">
        <h3>CTC/ColorUser</h3>
        <div>
          <span> <strong>Sélectionner le fichier des utilisateurs loccaux</strong></span><br />
          <input #fileUser type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, fileUser)" />
          <button (click)="sendNewUsers()">Importer</button>
        </div>
        <br />
        <div>
          <span> <strong>Sélectionner le fichier des CTCs</strong></span><br />
          <input #filectc type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, filectc)" />
          <button (click)="sendCTCs()">Importer</button>
        </div>
        <br />
        <div>
          <span> <strong>Sélectionner le fichier pour la MAJ des codeunisite des utilisateurs locaux (version temporaire pour maj des statusAdmin)</strong></span><br />
          <input #fileCU type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, fileCU)" />
          <button (click)="updateUnisiteCodeAndStatusAdmin()">Importer</button>
        </div>
        <br />
        <div>
          <span> <strong>Sélectionner le fichier pour la MAJ des codeunisite des utilisateurs locaux</strong></span><br />
          <input #fileCU type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, fileCU)" />
          <button (click)="updateUnisiteCode()">Importer</button>
        </div>
        <br />
        <div>
          <span> <strong>Sélectionner le fichier pour la MAJ des version des balance</strong></span><br />
          <input #fileCU type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, fileCU)" />
          <button (click)="sendVersions()">Importer</button>
        </div>


        <br />
        <div>
          <span> <strong>Sélectionner le fichier pour la MAJ des colorUser</strong></span><br />
          <input #fileColorUser type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="element" (change)="onFileChanged($event, fileColorUser)" />
          <button (click)="sendColorUser()">Importer</button>
        </div>

      </div>
    </div>
  </div>
</div> 
